import {Component, HostListener, OnInit} from '@angular/core';
import {FullUser} from '../../../../../models/full-user.model';
import {AdminService} from '../../../../../services/admin.service';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {Response} from '@angular/http';

@Component({
  selector: 'app-change-user-password',
  templateUrl: './change-user-password.component.html',
  styleUrls: ['./change-user-password.component.css']
})
export class ChangeUserPasswordComponent implements OnInit {
  user: FullUser;
  newPassword = '';
  successInfo = false;
  errorInfo = false;
  errorTwelve = false;
  errorLessChars = false;
  disabledBtn = false;

  constructor(public activeModal: NgbActiveModal,
              private adminService: AdminService) {
  }

  ngOnInit() {
    this.disabledBtn = false;
    this.successInfo = false;
    this.errorInfo = false;
    this.errorTwelve = false; // 412
    this.errorLessChars = false; // 412
  }

  @HostListener('paste', ['$event'])
  checkOnPaste(event) {
    const clipboardText: string = event.clipboardData.getData('Text');
    this.isValidPaste(clipboardText.split(''), event);
  }

  private isValidPaste(arrayChar: string[], event) {
    arrayChar.forEach(function (value) {
      const charCode = value.charCodeAt(0);
      if (charCode > 128 || charCode === 32) {
        event.preventDefault();
      }
    });
  }

  // Accept all key codes except 32 (space)
  checkInput(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 128 || charCode === 32) {
      return false;
    }
    return true;
  }

  setUserPass(u) {
    this.user = u;
  }

  setNewPassword() {
    this.disabledBtn = true;
    this.successInfo = false;
    this.errorInfo = false;
    this.errorTwelve = false; // 412
    this.errorLessChars = false;


    if (this.newPassword.length >= 6) {
      this.adminService.changeUserPassword(this.user.id, this.newPassword).subscribe(
        (response: any) => {
          if (response.status === 200) {
            this.successInfo = true;
            this.errorInfo = false;
            this.errorTwelve = false; // 412
            this.disabledBtn = false;
          }
        },
        (error) => {
          if (error.status === 412) {
            // 412 - юзер с указанным айди не найден
            this.successInfo = false;
            this.errorInfo = false;
            this.errorTwelve = true; // 412
          }
          this.successInfo = false;
          this.errorInfo = true;
          this.errorTwelve = false; // 412
          this.disabledBtn = false;
        });
    } else {
      this.successInfo = false;
      this.errorInfo = false;
      this.errorTwelve = false; // 412
      this.errorLessChars = true;
      this.disabledBtn = false;

    }

  }
}



// WEBPACK FOOTER //
// C:/work/new2/internal-frontend/src/app/content-page/views/view-group/popups/change-user-password/change-user-password.component.ts